"use client";

import { ComponentType, useEffect, useState } from "react";

import { Skeleton } from "@/components/ui/Skeleton";

export function LazyWatchDogPreview() {
  const [Preview, setPreview] = useState<ComponentType | null>(null);

  useEffect(() => {
    let isMounted = true;

    void import("@/components/index/sections/hero/NewHomePage").then((module) => {
      if (isMounted) {
        setPreview(() => module.WatchDogPreview);
      }
    });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      {Preview ? (
        <Preview />
      ) : (
        <Skeleton className="min-h-[32rem] w-full rounded-2xl !bg-softiq-secondary-shade-100/50" />
      )}
    </div>
  );
}
